import { ChangeEvent, type ReactNode } from 'react'
import classNames from 'classnames/bind'

import styles from './plain-toggle.module.scss';


const cx = classNames.bind(styles)

export type PlainToggleProps = {
  checked: boolean
  value: string
  disabled?: boolean
  name?: string
  id?: string
  className?: string
  label?: string
  labelClassName?: string
  coloredReverse?: boolean // deprecated use invertColors
  invertColors?: boolean
  bottomSpace?: boolean
  prefix?: ReactNode | string | null
  suffix?: ReactNode | string | null
  suffixClassName?: string
  prefixClassName?: string
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

const PlainToggle = ({
  checked,
  value,
  disabled,
  name,
  id,
  className,
  label,
  labelClassName,
  coloredReverse,
  invertColors,
  bottomSpace,
  prefix = 'Вкл',
  suffix,
  suffixClassName,
  prefixClassName,
  onChange,
}: PlainToggleProps) => {
  const currentId = id || `${name || ''}_${value}`

  return (
    <label
      htmlFor={currentId}
      className={cx(styles.root, { disabled }, className)}
    >
      {label
        && <span className={cx(styles.label, { disabled }, labelClassName)}>
          {label}
        </span>}

      <span className={styles.mainGroup}>
        {prefix
          && (typeof prefix === 'string'
            ? <span className={cx(styles.prefixText, { disabled }, prefixClassName)}>{prefix}</span>
            : <span className={cx(styles.prefix, prefixClassName)}>{prefix}</span>)}

        <input
          name={name}
          value={value}
          disabled={disabled}
          id={currentId}
          type="checkbox"
          className={styles.input}
          onChange={onChange}
          checked={checked}
        />

        <span className={styles.toggleElement}>
          <span className={styles.track} />
          <span className={cx(styles.thumb, { invertColors: invertColors || coloredReverse, disabled })} />
        </span>

        {suffix
          && (typeof suffix === 'string'
            ? <span className={cx(styles.suffixText, { disabled }, suffixClassName)}>{suffix}</span>
            : <span className={cx(styles.suffix, suffixClassName)}>{suffix}</span>)}
      </span>

      {bottomSpace
        && <span className={styles.bottomSpace} />}
    </label>
  )
}

export default PlainToggle
